export const TIMERs = {
  fiveSeconds: 5000,
  threeSeconds: 3000,
  oneSecond: 1000,
  three100Millis: 300,
};
